import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ag-page_assets position-relative" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { for: "currentPassword" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { for: "newPassword" }
const _hoisted_6 = {
  type: "submit",
  class: "border-0 pr-4 pl-4 pt-1 pb-1 ag-button ag-button_primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_card = _resolveComponent("ag-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ag_card, { module: _ctx.module }, {
      profile: _withCtx(() => [
        _createElementVNode("form", {
          class: "p-4",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.submitFunction($event)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("currentPassword")), 1),
            _withDirectives(_createElementVNode("input", {
              required: "",
              type: "password",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPassword) = $event)),
              class: "form-control",
              id: "currentPassword"
            }, null, 512), [
              [_vModelText, _ctx.currentPassword]
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("newPassword")), 1),
            _withDirectives(_createElementVNode("input", {
              required: "",
              type: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newPassword) = $event)),
              class: "form-control",
              id: "newPassword"
            }, null, 512), [
              [_vModelText, _ctx.newPassword]
            ])
          ]),
          _createElementVNode("button", _hoisted_6, _toDisplayString(_ctx.$t("save")), 1)
        ], 32)
      ]),
      _: 1
    }, 8, ["module"])
  ]))
}